import React, { FunctionComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { Link } from 'dibs-elements/exports/Link';
import styles from './SharedPopularSearchesLink.scss';
import type { SharedPopularSearchesLink_popularSearchesLink } from './__generated__/SharedPopularSearchesLink_popularSearchesLink.graphql';

type Props = {
    popularSearchesLink: SharedPopularSearchesLink_popularSearchesLink;
};

export const SharedPopularSearchesLinkComponent: FunctionComponent<Props> = ({
    popularSearchesLink,
}) => {
    if (!popularSearchesLink?.text || !popularSearchesLink?.path) {
        return null;
    }

    const { text, path } = popularSearchesLink;

    return (
        <div className={styles.popularSearches}>
            <Link href={path} dataTn="popular-searches-link">
                <FormattedMessage
                    id="SharedPopularSearchesLink.linkText"
                    defaultMessage="View All Popular <span>Category</span> Searches"
                    values={{
                        span: () => <span className={styles.popularSearchesCategory}>{text}</span>,
                    }}
                />
            </Link>
        </div>
    );
};

export const SharedPopularSearchesLink = createFragmentContainer(
    SharedPopularSearchesLinkComponent,
    {
        popularSearchesLink: graphql`
            fragment SharedPopularSearchesLink_popularSearchesLink on LinkData {
                text
                path
            }
        `,
    }
);
